var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-numberinput',{staticClass:"font-size-form input-number",attrs:{"size":"is-small","value":_vm.value,"controls-position":"compact"},on:{"input":function (v) { return _vm.$emit('update', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }